/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CreditScore = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.28249 9.28249C7.00247 7.5625 9.37644 6.5 12 6.5C14.6236 6.5 16.9975 7.5625 18.7175 9.28249C20.2637 10.8287 21.301 13.1211 21.4838 15.5H18.4661C18.3113 13.8169 17.6335 12.4411 16.5962 11.4038C16.4394 11.247 16.2747 11.0982 16.1025 10.9581L15.0347 12.0259C15.2112 12.1609 15.3785 12.3075 15.5355 12.4645C16.4292 13.3581 17 14.6021 17 16.25V17H23.0128V16.25C23.0128 13.2293 21.7797 10.2234 19.7782 8.22183C17.7884 6.23204 15.0374 5 12 5C8.96264 5 6.21161 6.23204 4.22183 8.22183C2.22514 10.2185 1 12.9723 1 16.25V17H6.91289V16.25C6.91289 14.8634 7.56291 13.366 8.46447 12.4645C9.37011 11.5588 10.6191 11 12 11C12.5813 11 13.1392 11.099 13.658 11.2813L14.8046 10.1347C13.9554 9.72799 13.0041 9.5 12 9.5C10.2053 9.5 8.57925 10.2284 7.40381 11.4038C6.38843 12.4192 5.64586 13.9518 5.45884 15.5H2.52461C2.69342 12.9541 3.72032 10.8446 5.28249 9.28249Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.4042 14.6609L18.1897 10.8754L17.129 9.81476L13.3436 13.6002C12.2965 13.0149 10.9481 13.1672 10.058 14.0573C8.98402 15.1313 8.98402 16.8725 10.058 17.9464C11.1319 19.0204 12.8731 19.0204 13.947 17.9464C14.8371 17.0564 14.9895 15.7079 14.4042 14.6609ZM11.1186 15.118C11.6068 14.6299 12.3982 14.6299 12.8864 15.118C13.3745 15.6062 13.3745 16.3976 12.8864 16.8858C12.3982 17.3739 11.6068 17.3739 11.1186 16.8858C10.6305 16.3976 10.6305 15.6062 11.1186 15.118Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.75 5.74996V10.25H11.25V5.74996H12.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
